<div class="billing-address">
  <div class="billing-address__label">Billing Address</div>
  <div class="billing-address__form-line">
    <div class="billing-address__form-line-two">
      <input type="text" name="addressLine" class="billing-address__input"
             id="address-1"
             placeholder="Address 1" [(ngModel)]="addressLine1" maxlength="50" (ngModelChange)="updateBillingAddress()"/>
      <p class="billing-address__input-error" *ngIf="fieldInvalid && !paymentStore.billingAddress?.address_line1">
        Please enter a valid address
      </p>
    </div>
    <div class="billing-address__form-line-two">
      <input type="text" name="addressLine"
             id="address-2"
             class="billing-address__input"
             placeholder="Address 2" [(ngModel)]="addressLine2" maxlength="50" (ngModelChange)="updateBillingAddress()"/>
    </div>
  </div>
  <!--  <div class="billing-address__form-line">-->
  <!--    <div class="billing-address__form-line-three">-->
  <!--      <input type="text" name="addressLine"-->
  <!--             class="billing-address__input"-->
  <!--             placeholder="Address 2" [(ngModel)]="addressLine2" maxlength="50" (ngModelChange)="updateBillingAddress()"/>-->
  <!--    </div>-->
  <!--    <div class="billing-address__form-line-three">-->
  <!--      <input type="text" name="addressLine"-->
  <!--             class="billing-address__input"-->
  <!--             placeholder="Address 3" [(ngModel)]="addressLine3" maxlength="50" (ngModelChange)="updateBillingAddress()"/>-->
  <!--    </div>-->
  <!--  </div>-->
  <div class="billing-address__form-line">
    <div class="billing-address__form-line-two">
      <input type="text" name="locality" class="billing-address__input"
             id="city"
             placeholder="City" [(ngModel)]="locality" maxlength="50" (ngModelChange)="updateBillingAddress()"/>
      <p class="billing-address__input-error" *ngIf="fieldInvalid && !paymentStore.billingAddress?.locality">
        Please enter a valid city
      </p>
    </div>
    <!--  </div>-->
    <!--  <div class="billing-address__form-line">-->
    <!--    <div class="billing-address__form-line-three">-->
    <!--      <input type="text" name="addressLine"-->
    <!--             class="billing-address__input"-->
    <!--             placeholder="Sublocality" [(ngModel)]="sublocality" maxlength="50" (ngModelChange)="updateBillingAddress()"/>-->
    <!--    </div>-->
    <!--    <div class="billing-address__form-line-three">-->
    <!--      <input type="text" name="addressLine"-->
    <!--             class="billing-address__input"-->
    <!--             placeholder="Sublocality 1" [(ngModel)]="sublocality1" maxlength="50" (ngModelChange)="updateBillingAddress()"/>-->
    <!--    </div>-->
    <!--    <div class="billing-address__form-line-three">-->
    <!--      <input type="text" name="addressLine"-->
    <!--             class="billing-address__input"-->
    <!--             placeholder="Sublocality 2" [(ngModel)]="sublocality2" maxlength="50" (ngModelChange)="updateBillingAddress()"/>-->
    <!--    </div>-->
    <!--  </div>-->
    <!--  <div class="billing-address__form-line">-->
    <div class="billing-address__form-line-four">
      <input type="text" name="administrativeDistrictLevel1" class="billing-address__input"
             id="state"
             placeholder="State" [(ngModel)]="administrativeDistrictLevel1" maxlength="50" (ngModelChange)="updateBillingAddress()"/>
      <p class="billing-address__input-error" *ngIf="fieldInvalid && !paymentStore.billingAddress?.administrative_district_level1">
        Please enter a valid state
      </p>
    </div>
    <!--    <div class="billing-address__form-line-three">-->
    <!--      <input type="text" name="administrativeDistrictLevel2"-->
    <!--             class="billing-address__input"-->
    <!--             placeholder="Administrative District Level 2" [(ngModel)]="administrativeDistrictLevel2" maxlength="50" (ngModelChange)="updateBillingAddress()"/>-->
    <!--    </div>-->
    <!--    <div class="billing-address__form-line-three">-->
    <!--      <input type="text" name="administrativeDistrictLevel3"-->
    <!--             class="billing-address__input"-->
    <!--             placeholder="Administrative District Level 3" [(ngModel)]="administrativeDistrictLevel3" maxlength="50" (ngModelChange)="updateBillingAddress()"/>-->
    <!--    </div>-->
    <!--  </div>-->
    <!--  <div class="billing-address__form-line">-->
    <div class="billing-address__form-line-four">
      <input type="text" name="postalCode" class="billing-address__input"
             id="post-code"
             placeholder="Postal code" [(ngModel)]="postalCode" maxlength="50" (ngModelChange)="updateBillingAddress()"/>

      <p class="billing-address__input-error" *ngIf="fieldInvalid && !paymentStore.billingAddress?.postal_code">
        Please enter a valid postal code
      </p>
    </div>
    <!--    <div class="billing-address__form-line-four">-->
    <!--      <input type="text" name="country"-->
    <!--             class="billing-address__input"-->
    <!--             placeholder="Country" [(ngModel)]="country" maxlength="50" (ngModelChange)="updateBillingAddress()"/>-->
    <!--    </div>-->
    <!--    <div class="billing-address__form-line-four">-->
    <!--      <input type="text" name="organization"-->
    <!--             class="billing-address__input"-->
    <!--             placeholder="Organization" [(ngModel)]="organization" maxlength="50" (ngModelChange)="updateBillingAddress()"/>-->
    <!--    </div>-->
  </div>
</div>
